/* eslint-disable import/prefer-default-export */
import { useMutation, useQuery } from 'react-query';
import {
  getUserAcknowledgments,
  createUserAcknowledgment,
  updateUserAcknowledgment,
} from '@apis/users';

interface UserAcknowledgment {
  feature: string;
  acknowledged: boolean;
}

interface UserUpdateAcknowledgment {
  feature: string;
  acknowledged: boolean;
}

const useGetUserAcknowledgments = (userId: string) =>
  useQuery<UserAcknowledgment[]>(
    ['useGetUserAcknowledgments', userId],
    async () => {
      const result = await getUserAcknowledgments();
      if (!('response' in result)) {
        throw result.error;
      }
      return result.response.data;
    },
    {
      suspense: true,
      refetchOnMount: true,
      enabled: !!userId,
    },
  );

const useCreateUserAcknowledgment = (feature: string) =>
  useMutation<UserAcknowledgment>(['useCreateUserAcknowledgment', feature], async () => {
    const result = await createUserAcknowledgment(feature, { feature });
    if (!('response' in result)) {
      throw result.error;
    }
    return result.response.data;
  });

const useUpdateUserAcknowledgment = (feature: string) =>
  useMutation<UserAcknowledgment, unknown, UserUpdateAcknowledgment>(
    ['useUpdateUserAcknowledgment', feature],
    async (payload) => {
      const result = await updateUserAcknowledgment(feature, payload);
      if (!('response' in result)) {
        throw result.error;
      }
      return result.response.data;
    },
  );

export {
  useGetUserAcknowledgments,
  useCreateUserAcknowledgment,
  useUpdateUserAcknowledgment,
};
